import React from 'react'
import Slider from './Component/Slider'
import Card from "./Component/Card"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { useRef } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import DestinationCard from "./Component/DestinationCard";
import "./Component/card.css"
import FixedDeparture from "./Component/fixeddepature"
import Footernav from "./Component/footernav"
import KnowUsBetter from './Component/video'
import WhyChooseUs from './Component/whychooseus'
const Home = () => {
  const [explore, setExplore] = useState("nepaltour");
    const hello = useRef(null)
    const fg = useRef(null)
  const [count,Setcount]=useState(1);
 let slide=()=>{
  if(count<5){
  hello.current.style.transform= `translateX(-${count * 25}vw)`;
  Setcount(count+1);
}
  else{
    hello.current.style.transform= `translateX(-${count * 0}vw)`;
    Setcount(1);
}
 }
 let sl=()=>{
  if(count==1){
  hello.current.style.transform= `translateX(-${count * 100}vw)`;
  Setcount(4);
}
  else{
    hello.current.style.transform= `translateX(${(count-2) * 25}vw)`;
    Setcount(count-1);
}}
let slid=()=>{
  if(count<5){
  fg.current.style.transform= `translateX(-${count * 25}vw)`;
  Setcount(count+1);
}
  else{
    fg.current.style.transform= `translateX(-${count * 0}vw)`;
    Setcount(1);
}
 }
 let s=()=>{
  if(count==1){
  fg.current.style.transform= `translateX(-${count * 100}vw)`;
  Setcount(4);
}
  else{
    fg.current.style.transform= `translateX(${(count-2) * 25}vw)`;
    Setcount(count-1);
}}
  return (
    <main>
    <Slider/>
    <section className="Offer-segment">
      <section className='offer-Top'>
      <div className='offer-left'>
        <div className="left-offer-in">
          <h1>OFFERS</h1>
          <div className="offer-nav">
            <div id='offer-nav-item'
             className={explore === "nepaltour" ? "test" : ""}
             onClick={() => setExplore("nepaltour")}>Nepal Tour</div>
            <div id="offer-nav-item"
            className={explore === "hotel" ? "test" : ""}
            onClick={() => setExplore("hotel")}>Car</div>
            <div id="offer-nav-item"
            className={explore === "guide" ? "test" : ""}
            onClick={() => setExplore("guide")}>Activity</div>
            <div id="offer-nav-item"
            className={explore === "activity" ? "test" : ""}
            onClick={() => setExplore("activity")}>Guide</div>
          </div>
        </div>
      </div>
      <div className="offer-right">
      <p>Show All</p>
        <FontAwesomeIcon icon={faArrowAltCircleRight}></FontAwesomeIcon>
      </div>
      </section>
      <section className="offer-bottom">
      <button className="leftArrow"onClick={() => sl()}>
        ❮
      </button>
        <div id="destination-card"className={explore === "nepaltour" ? "display-fordestination" : ""}
            onClick={() => setExplore("nepaltour")} ref={hello}>
               <Card src="img/pokhara/pokhara3dslr.jpeg" title="Heritage & Horizon Tour" location="Kathmandu And 2 Other City" time="6 days" rat="$890" sr="/kathmandu-pokhara-6days-tours"/>
 <Card src="img/chitwan/chitwandslr.webp" title="Nepal's Golden Triangle" location="Pokhara And 2 Other City" time="8 days" rat="$940" sr="/kathmandu-chitwan-pokhara-8days-nepaltour"/>
          <Card src="img/capital/pasupatinath.jpg" title="7 Unesco Heritage Sites" location="Bouddha + 6 Other Place" time="1 days" rat="$190" sr="/one-day-nepal-7unescoheritage-tour"/>
          <Card src="img/capital/namobuddha.webp" title="Bhuddhism Tour" location="Lumbini And other Bhuddhist places" time="13 days" rat="$3600" sr="/buddhism-tour-nepal"/>
          <Card src="img/treek/Dhampus.webp" title="Nature's Majestic Loop" location="kathmandu And 7 Other City" time="10 days" rat="$2350" sr="/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"/>
         
          <Card src="img/capital/swyambhunathdslr.jpeg"title="The Big Four" location="Kathmandu-4 Places" time="1 days" rat="$140"sr="/One-Day-Kathmandu-Tour"/>
            <Card src="img/capital/capital2dslr.jpeg" title="Nepal's Essential Four" location="Pokhara And 3 Other City" time="8 days" rat="$1100" sr="/kathmandu-chitwan-lumbini-pokhara-8days-tour"/>
            <Card src="img/chitwan/Chitwan.jpg" title="Wilderness & Wisdom" location="Kathmandu And 2 Other City" time="6 days" rat="$1150" sr="/kathmandu-chitwan-lumbini"/>
           
        </div>
        <div id="destination-card" className={explore === "hotel" ? "display-fordestination" : ""}
            onClick={() => setExplore("hotel")}>
          {/* <Card src="img/bouddha.jpg"title="One Day kathmandu Tour" location="Kathmandu-4 Places" time="1 days" price="90" sr="/One-Day-Kathmandu-Tour.js"/>
          <Card src="img/Chitwan.jpg" title="The Golden Route" location="Kathmandu And 3 Other City" time="10 days" price="1290" sr="/10days-nepaltour"/>
          <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/Dhampus.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/> */}
           <Card src="/img/company/Capture.JPG"title="Service Not Avilable Right Now"></Card>
        </div>
        <div id="destination-card"className={explore === "guide" ? "display-fordestination" : ""}
            onClick={() => setExplore("guide")}>
          {/* <Card src="img/tal barahi.webp" title="The Trinity of the Hills" location="Kathmandu, Pokhara, Nagarkot" time="6 days" price="890" sr="/kathmandu-pokhara-6days-tours"/>
          <Card src="img/bouddha.jpg"title="One Day kathmandu Tour" location="Kathmandu-4 Places" time="1 days" price="90" sr="/One-Day-Kathmandu-Tour.js"/>
          <Card src="img/Chitwan.jpg" title="The Golden Route" location="Kathmandu And 3 Other City" time="10 days" price="1290" sr="/10days-nepaltour"/>
          <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/Dhampus.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/> */}
             <Card src="/img/company/Capture.JPG"title="Service Not Avilable Right Now"></Card>
        </div>
        <div id="destination-card"className={explore === "activity" ? "display-fordestination" : ""}
            onClick={() => setExplore("activity")}>
          {/* <Card src="/img/activity/raftng.webp" title="The Trinity of the Hills" location="Kathmandu, Pokhara, Nagarkot" time="6 days" price="890" sr="/kathmandu-pokhara-6days-tours"/>
          <Card src="img/bouddha.jpg"title="One Day kathmandu Tour" location="Kathmandu-4 Places" time="1 days" price="90" sr="/One-Day-Kathmandu-Tour.js"/>
          <Card src="img/Chitwan.jpg" title="The Golden Route" location="Kathmandu And 3 Other City" time="10 days" price="1290" sr="/10days-nepaltour"/>
          <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/Dhampus.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/>
            <Card src="img/bandipur.jpg" title="The Classic Heritage Loop" location="Pokhara And 4 Other City" time="9 days" price="1190" sr="/9days-nepaltour"/> */}
<Card src="/img/company/Capture.JPG"title="Service Not Avilable Right Now"></Card>
        </div>
        <button className="rightArrow" onClick={() => slide()}>
        ❯
      </button>
      </section>
    </section>
    <section className="Offer-segment">
      <section className='offer-Top align'>
      <div className='offer-left'>
        <div className="left-offer-in">
          <h1>Popular Packages</h1>
        </div>
      </div>
      <div className="offer-right no-not">
        <p>Show All</p>
        <FontAwesomeIcon icon={faArrowAltCircleRight}></FontAwesomeIcon>
      </div>
      </section>
      <section className="offer-bottom">
      <button className="leftArrow" onClick={() => s()}>
        ❮
      </button>
        <div className="destination-card" ref={fg}>
        <DestinationCard src="/img/mounteve/Heli1.webp" className="very-p black-white" title="Mt Everest Heli Tour" nepalprice="$1400" srcq="/Everest-Heli-Tour" dur="4 Hrs"/>
        <DestinationCard src="/img/capital/nagarkot.webp" className="very-p blue" title="The Quick & Classic" nepalprice="$425" srcq="/kathmandu-nagarkot-4days-tour"dur="3N/4D"/>
        <DestinationCard src="/img/chitwan/chitwan5dslr.jpeg" className="very-p black"title="Peak & safaris"  nepalprice="$890"srcq="/kathmandu-chitwan-nagarkot" dur="6N/5D"/>
        <DestinationCard src="/img/mounteve/moun1.webp" className="very-p"title="Mountain Flight"  nepalprice="$280"srcq="/mountain-flight-nepal-tour" dur="1 Hrs"/>
        <DestinationCard src="/img/pokhara/bandipur1dslr.jpeg" className="very-p black-whit"title="The Classic Circuits"  nepalprice="$1600"srcq="/kathmandu-chitwan-pokhara-bandipur-nagarkot-9days-tour" dur="8N/9D"/>
        <DestinationCard src="/img/chitwan/chitwan3dslr.webp" className="very-p blue"title="Peaks Parks Peace"  nepalprice="$2400"srcq="/kathmandu-chitwan-pokhara-lumbini-bandipur-nagarkot-11days-tour" dur="9N/10D"/>
        <DestinationCard src="/img/company/airportdslr.jpeg" className="very-p"title="All Nepal"  nepalprice="$4200"srcq="/all-nepal-tour" dur="14N/15D"/>
        <DestinationCard src="/img/capital/meditation.webp" className="very-p blue"title="Pure Himalayan Healing"  nepalprice="$2220"srcq="/nepal-wellness-retreat-7days-tour" dur="6N/7D"/>
        </div>
        <button className="rightArrow" onClick={() => slid()}>
        ❯
      </button>
      </section>
    </section>
    <FixedDeparture/>
    <WhyChooseUs/>
    <KnowUsBetter/>
    <Footernav/>
    </main>
  )
}

export default Home